import C from './container';

export default C;
